import React, { useEffect, useRef, useState } from 'react'
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from 'react-hook-form';
import ApiHelper from '../../helperFunction/ApiHelper';
import API_ENDPOINTS from '../../helperFunction/Constant';
import { Toast } from 'primereact/toast';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Layout from '../common/Layout';

const AddQuestions = () => {

    const { quizId, sectionId, id } = useParams()

    const navigate = useNavigate()
    
    const isEdit = id ? true : false
    const toast = useRef(null)

    useEffect(() => {
        isEdit && getQuizQuestions()
    }, [])

    const schema = yup.object({
        questionId: yup.string().optional().nullable(), 
        question: yup.string().required("Question is required"),
        isActive: yup.boolean(),
    });

    const { register, handleSubmit, reset, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });

    const resetValue = () => {
        reset({
            questionId: null,
            question: '',
            isActive: false,
        })
    }

    const getQuizQuestions = () => {
        ApiHelper.get(`${API_ENDPOINTS.QUIZ_QUESTIONS}/edit/${id}`).then((res) => {
            console.log('res:',res);
            if (res.status === 200) {
                reset({
                    questionId: res.data.data.quizId,
                    question: res.data.data.question,
                    isActive: res.data.data.isActive,
                })
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    }

    const onSubmit = (data) => {
        data.sectionId = sectionId
        data.quizId = quizId
        data.displayOrder = 0
        if (data.questionId) {
            update(data, data.questionId)
        } else {
            add(data)
        }
    };

    const add = (data) => {
        ApiHelper.post(`${API_ENDPOINTS.QUIZ_QUESTIONS}/${quizId}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate(-1)
                }, 1000)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const update = (data) => {
        ApiHelper.put(`${API_ENDPOINTS.QUIZ_QUESTIONS}/edit/${id}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate(-1)
                }, 1000)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

  return (
    <>
        <Toast ref={toast} />
        <Layout>
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                    <div class="d-flex justify-content-between align-items-center py-3">
                        <h4 class="fw-bold py-3 mb-2">
                            <span class="d-flex text-muted fw-light"> 
                                <p class="breadcrumb-item pageHeader active me-2 mb-0" aria-current="page" onClick={() => navigate(`/quiz/${quizId}/section/${sectionId}/questions`)}> Manage Questions </p> / <b className='mx-2'> {isEdit ? 'Edit' : "Add"} </b>
                            </span>
                        </h4>
                        <Link to={`/quiz/${quizId}/section/${sectionId}/questions`} class="btn btn-secondary">⬅ Go Back</Link>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card mb-4">
                                <div class="card-body">
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <div class="row mb-3">
                                            <div class="col-md-9 mb-3">
                                                <label class="form-label">Question</label>
                                                <textarea type="text" name="question" class="form-control" {...register("question")} />
                                                <small className="text-danger">{errors.question?.message}</small>
                                            </div>
                                            <div class="col-md-3 mb-3">
                                                <label class="form-label">Status</label>
                                                <div class="form-check form-switch mb-2">
                                                    <input class="form-check-input mt-2" name="isActive" type="checkbox" id="flexSwitchCheckDefault" {...register("isActive")} />
                                                </div>
                                            </div>
                                            <input type='hidden' {...register("questionId")}/>
                                        </div>
                                        <div class="mt-4 mb-3">
                                            <button type="submit" class="btn btn-primary me-3">Save</button>
                                            <button type="button" onClick={() => resetValue()} class="btn btn-secondary reset-btn">Reset</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
        
    </>
  )
}

export default AddQuestions